export const TournamentStatus = Object.freeze({
  CREATED: 0,
  OPEN_FOR_INSCRIPTIONS: 1,
  CLOSED_FOR_INSCRIPTIONS: 2,
  IN_PROGRESS: 3,
  FINISHED: 4,
  CANCELLED: 5
});
